import ENV from "~/constants";
import {
  type Configuration,
  PublicClientApplication,
  LogLevel,
} from "@azure/msal-browser";

const clientId = ENV.REACT_APP_AD_CLIENT_ID;
const tenantId = ENV.REACT_APP_AD_TENANT_ID;

export const loginRequest = {
  // The access token from this request is forwarded by the gateway to
  // Microsoft Graph (GET /me). It therefore must carry a Graph delegated
  // scope that permits reading the profile, otherwise Graph replies 403
  // Authorization_RequestDenied and /auth/connect fails with 500.
  // We use "User.Read.All" because it is the scope this app registration
  // actually has admin consent for (AllPrincipals) — so the token is
  // acquired silently without a per-user consent prompt. ("User.Read" is
  // neither declared on the app registration nor consented.)
  scopes: ["openid", "offline_access", "User.Read.All"],
};

// MSAL configuration
export const msalConfig: Configuration = {
  auth: {
    clientId: clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
  },
system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            break;
          case LogLevel.Warning:
            console.warn(message);
            break;
          default:
            break;
        }
      },
      piiLoggingEnabled: false,
    },
    navigateFrameWait: 2000,
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);
